// src/components/practice/tasks/writing/parsers/osdC1EmailParser.js
// Parser for OSD C1 Formal Response Email with side notes

export const parseOsdC1EmailWithNotes = (content) => {
    if (!content) return null;

    const result = {
        from: '',
        to: '',
        subject: '',
        date: '',
        salutation: '',
        paragraphs: [],
        closing: []
    };

    // Extract email headers dynamically
    const fromMatch = content.match(/Von:\s*([^.]+(?:\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})?)/);
    const toMatch = content.match(/An:\s*([^.]+(?:\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})?)/);
    const subjectMatch = content.match(/Betreff:\s*([^.]+?)(?=\.|Sehr geehrte)/);
    const dateMatch = content.match(/Datum:\s*([^.]+)/);

    if (fromMatch) result.from = fromMatch[1].trim();
    if (toMatch) result.to = toMatch[1].trim();
    if (subjectMatch) result.subject = subjectMatch[1].trim();
    if (dateMatch) result.date = dateMatch[1].trim();

    // Remove all headers from content
    let bodyContent = content
        .replace(/Von:\s*[^.]+(?:\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})?[.,]?\s*/i, '')
        .replace(/An:\s*[^.]+(?:\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})?[.,]?\s*/i, '')
        .replace(/Betreff:\s*[^.]+?[.,]?\s*(?=Sehr|Datum)/i, '')
        .replace(/Datum:\s*[^.]+[.,]?\s*/i, '')
        .trim();

    // Extract salutation
    const salutationMatch = bodyContent.match(/^(Sehr geehrte(?:r?|\/r)\s+[^,]+,?)/);
    if (salutationMatch) {
        result.salutation = salutationMatch[1];
        bodyContent = bodyContent.replace(salutationMatch[1], '').trim();
    }

    // Extract closing before processing paragraphs
    const closingMatch = bodyContent.match(/(Mit freundlichen Grüßen[\s\S]*?)(?:\[Notiz:|$)/);
    if (closingMatch) {
        result.closing = closingMatch[1].split(/\r?\n/).map(line => line.trim()).filter(Boolean);
        bodyContent = bodyContent.replace(closingMatch[1], '').trim();
    }

    // Split content by sentences/paragraphs, keeping track of notes
    // Strategy: Split by [Notiz:...] and associate each note with the text before it
    const segments = bodyContent.split(/(\[Notiz:[^\]]+\])/);

    let currentParagraph = '';

    for (let i = 0; i < segments.length; i++) {
        const segment = segments[i].trim();

        if (segment.startsWith('[Notiz:')) {
            // This is a note - extract it
            const noteText = segment.replace('[Notiz:', '').replace(']', '').trim();

            // Associate note with current paragraph
            if (currentParagraph) {
                result.paragraphs.push({
                    text: currentParagraph.trim(),
                    note: noteText
                });
                currentParagraph = '';
            }
        } else if (segment) {
            // This is text content
            // Check if this should start a new paragraph or continue current one
            if (currentParagraph) {
                // Add to current paragraph
                currentParagraph += ' ' + segment;
            } else {
                // Start new paragraph
                currentParagraph = segment;
            }
        }
    }

    // Add any remaining paragraph without a note
    if (currentParagraph.trim()) {
        result.paragraphs.push({
            text: currentParagraph.trim(),
            note: null
        });
    }

    console.log('Parsed OSD C1 email with notes:', result);
    return result;
};